import { render, staticRenderFns } from "./OtherpurchaseReport.vue?vue&type=template&id=49cfc02e"
import script from "./OtherpurchaseReport.vue?vue&type=script&lang=js"
export * from "./OtherpurchaseReport.vue?vue&type=script&lang=js"
import style0 from "./OtherpurchaseReport.vue?vue&type=style&index=0&id=49cfc02e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports